// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#draggableWindow[data-v-1cd0e7a4]{position:absolute;right:0;z-index:9000;background-color:#fff;border:1px solid var(--primary);text-align:center}#draggableWindowheader[data-v-1cd0e7a4]{display:flex;padding:10px;cursor:move;z-index:10;background-color:var(--primary);color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
